import { useLaboratory } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

type Props = {
  onClose: () => void
  id?: string
  price?: string
}

export const priceSchema = yup.object({
  price: yup
    .string()
    .required('Price is required')
    .matches(/^[0-9]+(\.[0-9]{1,2})?$/, 'Invalid price format')
})

export const EditPricing = ({ id, onClose, price }: Props) => {
  const methods = useForm({ defaultValues: { price: price || '' }, resolver: yupResolver(priceSchema) })
  const { updateLaboratory } = useLaboratory()

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = methods

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          price: data.price
        },
        type: 'laboratories'
      }
    }

    try {
      await updateLaboratory({ data: payload, id: id || '' })
      showToast('Pricing updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title="Edit Laboratory Pricing">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} width={'530px'}>
            <Box className="mx-auto w-full max-w-[399px]" flex={false} gap={'20px'}>
              <Box pad="0">
                <FormInputField label="Price" name="price" placeholder="" type="number" />
              </Box>
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={handleClose} submit="Update" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
